export const FIELD_LIST_TYPE_MEASURE_UNIT: string = 'measure-unit';
export const FIELD_LIST_TYPE_PRICING_TYPE: string = 'pricing-type';
